import Quill from 'quill';
import { type InlineBlot } from 'parchment';
import { type BlotConstructorWithNodeType } from '../../extendedQuillTypes';

const Inline = Quill.import('blots/inline') as BlotConstructorWithNodeType<
	HTMLSpanElement,
	InlineBlot
>;

class CustomSpan extends Inline {
	static blotName: string;
	static className: string;
	static tagName: string;

	static formats() {
		return true;
	}
}

class FootnoteRefTail extends CustomSpan {}
FootnoteRefTail.blotName = 'footnote-ref-tail';
FootnoteRefTail.className = 'footnote-ref-tail';
FootnoteRefTail.tagName = 'span';

const FIGURE_REFERENCE_ATTRIBUTES = ['class', 'data-figure-id', 'data-format'];
class WebtextFigureReference extends Inline {
	static create(value) {
		const node = document.createElement('span');
		Object.keys(value).map((key) => node.setAttribute(key, value[key]));

		return node;
	}

	static formats(domNode) {
		const attributes = domNode.attributes;
		const attrMap = {};

		for (let index = 0; index < attributes.length; index++) {
			const attribute = attributes[index];
			if (FIGURE_REFERENCE_ATTRIBUTES.includes(attribute.name))
				attrMap[attribute.name] = attribute.value;
		}

		return attrMap;
	}
}
WebtextFigureReference.blotName = 'webtext-figure-reference';
WebtextFigureReference.className = 'webtext-figure-reference';
WebtextFigureReference.tagName = 'span';

class WebtextSourceUrl extends CustomSpan {}
WebtextSourceUrl.blotName = 'webtext-source-url';
WebtextSourceUrl.className = 'webtext-source-url';
WebtextSourceUrl.tagName = 'span';

class WebtextMath extends CustomSpan {}
WebtextMath.blotName = 'webtext-math';
WebtextMath.className = 'webtext-math';
WebtextMath.tagName = 'span';

class VisuallyHidden extends CustomSpan {}
VisuallyHidden.blotName = 'visually-hidden';
VisuallyHidden.className = 'visually-hidden';
VisuallyHidden.tagName = 'span';

class WebtextGlossaryTermLocations extends CustomSpan {}
WebtextGlossaryTermLocations.blotName = 'webtext-glossary-term-locations';
WebtextGlossaryTermLocations.className = 'webtext-glossary-term-locations';
WebtextGlossaryTermLocations.tagName = 'span';

class WebtextBigLinkTitle extends CustomSpan {}
WebtextBigLinkTitle.blotName = 'webtext-big-link-title';
WebtextBigLinkTitle.className = 'webtext-big-link-title';
WebtextBigLinkTitle.tagName = 'span';

class WebtextBigLinkCredit extends CustomSpan {}
WebtextBigLinkCredit.blotName = 'webtext-big-link-credit';
WebtextBigLinkCredit.className = 'webtext-big-link-credit';
WebtextBigLinkCredit.tagName = 'span';

class WebtextPullquoteHeading extends CustomSpan {}
WebtextPullquoteHeading.blotName = 'webtext-pullquote-heading';
WebtextPullquoteHeading.className = 'webtext-pullquote-heading';
WebtextPullquoteHeading.tagName = 'span';

class KeyPoint extends CustomSpan {}
KeyPoint.blotName = 'key-point';
KeyPoint.className = 'key-point';
KeyPoint.tagName = 'span';

class WebtextArticleSourceName extends CustomSpan {}
WebtextArticleSourceName.blotName = 'webtext-article-source-name';
WebtextArticleSourceName.className = 'webtext-article-source-name';
WebtextArticleSourceName.tagName = 'span';

class IconTechTip extends CustomSpan {}
IconTechTip.blotName = 'icon-tech-tip';
IconTechTip.className = 'icon-tech-tip';
IconTechTip.tagName = 'span';

/* Possible class values:
	'webtext-decoration a',
	'webtext-decoration b',
	'webtext-decoration c',
	'webtext-decoration c weak'
*/
class WebtextDecoration extends Inline {
	static create(value) {
		const node = super.create();
		node.setAttribute('class', value); // value is taken from formats

		return node;
	}

	static formats(domNode) {
		return domNode.getAttribute('class');
	}
}
WebtextDecoration.blotName = 'webtext-decoration';
WebtextDecoration.className = 'webtext-decoration';
WebtextDecoration.tagName = 'span';

export {
	FootnoteRefTail,
	WebtextFigureReference,
	WebtextSourceUrl,
	WebtextMath,
	VisuallyHidden,
	WebtextGlossaryTermLocations,
	WebtextBigLinkTitle,
	WebtextBigLinkCredit,
	WebtextPullquoteHeading,
	KeyPoint,
	WebtextArticleSourceName,
	IconTechTip,
	WebtextDecoration
};
